import { render, staticRenderFns } from "./ActionAddSystemFlag.vue?vue&type=template&id=b1c86268"
import script from "./ActionAddSystemFlag.vue?vue&type=script&lang=js"
export * from "./ActionAddSystemFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports